import React__default from 'react';
import { Icon } from '../components/internal/Icon.mjs';

function EllipsisIcon(props) {
  return /* @__PURE__ */ React__default.createElement(Icon, {
    fill: "currentColor",
    ...props
  }, /* @__PURE__ */ React__default.createElement("circle", {
    cx: 5,
    cy: 10,
    r: 0.75
  }), /* @__PURE__ */ React__default.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 0.75
  }), /* @__PURE__ */ React__default.createElement("circle", {
    cx: 15,
    cy: 10,
    r: 0.75
  }));
}

export { EllipsisIcon };
//# sourceMappingURL=Ellipsis.mjs.map
